export default __webpack_public_path__ + "static/media/Monogramlogo.10b88f83.jpeg";